import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { 
  TextField, 
  Button, 
  Container, 
  Typography, 
  Box, 
  Alert,
  Link,
  Paper
} from '@mui/material';
import api from '../api/axios';

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
});

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <Container maxWidth="xs">
      <Box mt={8}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h5" align="center" gutterBottom>
            Forgot Password
          </Typography>
          <Typography variant="body2" align="center" color="textSecondary" sx={{ mb: 3 }}>
            Enter your email address and we'll send you a link to reset your password.
          </Typography>
          
          {!isSubmitted ? (
            <Formik
              initialValues={{ email: '' }}
              validationSchema={ForgotPasswordSchema}
              onSubmit={async (values, { setSubmitting }) => {
                setError('');
                setMessage('');
                try {
                  const res = await api.post('/auth/forgot-password', values);
                  setMessage(res.data.message);
                  setIsSubmitted(true);
                  
                  // Show reset token in development (remove in production)
                  if (res.data.resetToken) {
                    setMessage(prev => prev + `\n\nReset Token: ${res.data.resetToken}\nReset URL: ${res.data.resetUrl}`);
                  }
                } catch (err) {
                  setError(err.response?.data?.message || 'An error occurred');
                }
                setSubmitting(false);
              }}
            >
              {({ isSubmitting, errors, touched }) => (
                <Form>
                  <Field
                    as={TextField}
                    name="email"
                    label="Email"
                    fullWidth
                    margin="normal"
                    error={touched.email && !!errors.email}
                    helperText={touched.email && errors.email}
                  />
                  {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={isSubmitting}
                    sx={{ mt: 2 }}
                  >
                    Send Reset Link
                  </Button>
                  <Box sx={{ mt: 2, textAlign: 'center' }}>
                    <Link href="/login" variant="body2">
                      Back to Login
                    </Link>
                  </Box>
                </Form>
              )}
            </Formik>
          ) : (
            <Box>
              <Alert severity="success" sx={{ mb: 2 }}>
                {message}
              </Alert>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => navigate('/login')}
              >
                Back to Login
              </Button>
            </Box>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default ForgotPasswordPage; 